import { render } from "./seat.vue?vue&type=template&id=07498b95&ts=true"
import script from "./seat.vue?vue&type=script&lang=ts"
export * from "./seat.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/seat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07498b95"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07498b95', __exports__)) {
    console.log('reload')
    api.reload('07498b95', __exports__)
  }
  
  module.hot.accept("./seat.vue?vue&type=template&id=07498b95&ts=true", () => {
    console.log('re-render')
    api.rerender('07498b95', render)
  })

}


export default __exports__